export const MONTHS = [
  "Oct 25",
  "Nov 25",
  "Dec 25",
  "Jan 26",
  "Feb 26",
  "Mar 26",
  "Apr 26",
  "May 26",
  "Jun 26",
  "Jul 26",
  "Aug 26",
  "Sep 26",
] as const

export const MONTH_NAMES = [
  "October 2025",
  "November 2025",
  "December 2025",
  "January 2026",
  "February 2026",
  "March 2026",
  "April 2026",
  "May 2026",
  "June 2026",
  "July 2026",
  "August 2026",
  "September 2026",
] as const

export const LAST_MONTH = MONTHS.length - 1

export type Chapter = {
  ata: string
  name: string
  alert: number | null
}

export const CHAPTERS: Chapter[] = [
  { ata: "05", name: "Time limits / checks", alert: 16 },
  { ata: "12", name: "Servicing", alert: 10 },
  { ata: "21", name: "Air conditioning", alert: 14 },
  { ata: "22", name: "Auto flight", alert: null },
  { ata: "23", name: "Communications", alert: 12 },
  { ata: "24", name: "Electrical power", alert: 10 },
  { ata: "25", name: "Equipment / furnishings", alert: 10 },
  { ata: "26", name: "Fire protection", alert: 6 },
  { ata: "27", name: "Flight controls", alert: 12 },
  { ata: "28", name: "Fuel", alert: 6 },
  { ata: "30", name: "Ice & rain protection", alert: 12 },
  { ata: "31", name: "Indicating / recording", alert: 16 },
  { ata: "32", name: "Landing gear", alert: 14 },
  { ata: "33", name: "Lights", alert: 12 },
  { ata: "34", name: "Navigation", alert: 10 },
  { ata: "35", name: "Oxygen", alert: 6 },
  { ata: "36", name: "Pneumatic", alert: 8 },
  { ata: "52", name: "Doors", alert: 10 },
  { ata: "72", name: "Engine", alert: 8 },
  { ata: "73", name: "Engine fuel & control", alert: 8 },
  { ata: "79", name: "Engine oil", alert: null },
]

export const REPORT_SOURCES = ["PIREP", "MAREP"] as const

export type ReportSource = (typeof REPORT_SOURCES)[number]

export type Report = {
  ata: string
  source: ReportSource
}

export type MonthStats = {
  days: number
  hours: number
  departures: number
  delays: number
  cancellations: number
  reports: Report[]
}

export type Availability = "available" | "in-check" | "aog" | "stored"

export function seeded(seed: string): () => number {
  let state = [...seed].reduce(
    (hash, char) => (hash * 31 + char.charCodeAt(0)) >>> 0,
    7,
  )
  return () => {
    state = (state * 1664525 + 1013904223) >>> 0
    return state / 4294967296
  }
}

function reportsOf(
  random: () => number,
  source: ReportSource,
  count: number,
): Report[] {
  return Array.from({ length: count }, () => ({
    ata: CHAPTERS[Math.floor(random() * CHAPTERS.length)].ata,
    source,
  }))
}

export function tailMonths(
  registration: string,
  availability: Availability,
): MonthStats[] {
  const random = seeded(registration)

  return MONTHS.map((_, index) => {
    if (availability === "stored" && index >= LAST_MONTH - 2) {
      return {
        days: 0,
        hours: 0,
        departures: 0,
        delays: 0,
        cancellations: 0,
        reports: [],
      }
    }
    const inCheck = availability === "in-check" && index === LAST_MONTH
    const days = inCheck ? 9 : 18 + Math.floor(random() * 9)
    const hours = Math.round(days * (1.6 + random() * 1.2) * 10) / 10
    return {
      days,
      hours,
      departures: Math.round(hours / (1.3 + random() * 0.6)),
      delays: random() < 0.88 ? 0 : 1,
      cancellations: random() < 0.985 ? 0 : 1,
      reports: [
        ...reportsOf(random, "PIREP", Math.floor(random() * 3.6)),
        ...reportsOf(random, "MAREP", Math.floor(random() * 2.4)),
      ],
    }
  })
}
